import { render, staticRenderFns } from "./DashboardFilterCores.vue?vue&type=template&id=4c4bc08d"
import script from "./DashboardFilterCores.vue?vue&type=script&lang=js"
export * from "./DashboardFilterCores.vue?vue&type=script&lang=js"
import style0 from "./DashboardFilterCores.vue?vue&type=style&index=0&id=4c4bc08d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports